import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import useCustomFetchQuery from "../../../../Hooks/useCustomFecthQuery";
import usePost from "../../../../Hooks/usePost";
import Divider from "./Divider";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import ButtonSubmit from "../../../Buttons/ButtonSubmit";
import TermsAndCondition from "./TermsAndCondition";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomCheckbox = styled(Checkbox)({
  color: "#F68A20",
  "&.Mui-checked": {
    color: "#F68A20",
  },
  "& .MuiSvgIcon-root": {
    borderColor: "#F68A20",
  },
  "&:not(.Mui-checked) .MuiSvgIcon-root": {
    border: `1px solid #F68A20`,
    borderRadius: "2px",
  },
});

const FreeRegisterNow = ({
  eventID,
  eventDetails,
  firstName,
  lastName,
  email,
  phone,
  redirect,
}) => {
  const [termsModal, setTermsModal] = useState(false);
  const [formContent, setFormContent] = useState([]);
  const [inputs, setInputs] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const { status, execute, pending } = usePost();
  const navigate = useNavigate();

  // Helper function to format camelCase to Title Case
  const formatLabel = (label, name) => {
    if (label && label !== name) {
      // If label exists and is different from name, use it
      return label;
    }
    // Convert camelCase to Title Case as fallback
    if (name) {
      return name
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
        .trim();
    }
    return label || name || '';
  };

  const {
    data: eventForm,
    error: eventFormError,
    isLoading: isEventFormLoading,
  } = useCustomFetchQuery(
    ["eventForm", eventID],
    `${process.env.REACT_APP_API}event-form/${eventID}`,
    null,
    { enabled: !!eventID }
  );

  useEffect(() => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      ...(firstName && { firstName }),
      ...(lastName && { lastName }),
      ...(email && { email }),
      ...(phone && { phoneNumber: phone }),
    }));
  }, [firstName, lastName, email, phone]);

  const handleRegister = (e) => {
    e.preventDefault();
    let isValid = true;
    const newErrors = {};

    // First name validation
    if (!inputs.firstName) {
      newErrors.firstName = "First name is required.";
      isValid = false;
    }

    // Last name validation
    if (!inputs.lastName) {
      newErrors.lastName = "Last name is required.";
      isValid = false;
    }

    // Phone number validation
    if (!inputs.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required.";
      isValid = false;
    }

    // Email validation (basic regex to check format)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!inputs.email) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (!emailRegex.test(inputs.email)) {
      newErrors.email = "Please enter a valid email.";
      isValid = false;
    }

    // Terms and conditions checkbox validation
    if (!isChecked) {
      newErrors.checkbox = "You must agree to the terms and conditions.";
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) return;

    const customFields = formContent.slice(4)?.map((field) => ({
      label: field.label,
      value:
        field.question_type === "checkbox"
          ? inputs[field.name]
            ? "Yes"
            : "No"
          : inputs[field.name] || "",
    }));

    const registrationData = {
      firstName: inputs.firstName,
      lastName: inputs.lastName,
      email: inputs.email,
      phoneNumber: inputs.phoneNumber,
      customFields: customFields,
      communicationConsent: true,
    };

    
    execute(
      `attendees/add/${eventID}`,
      JSON.stringify(registrationData),
      "POST",
      "Successfully Registered. Please check your email for event entrance details",
      null,
      true,
      true
    );
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handlePhoneChange = (value) => {
    setInputs((prevInputs) => ({ ...prevInputs, phoneNumber: value }));
    setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: "" }));
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setErrors((prevErrors) => ({ ...prevErrors, checkbox: "" }));
  };

  const openPolicy = () => {
    setTermsModal(!termsModal);
  };

  useEffect(() => {
    if (eventForm?.data?.[0]?._id) {
      setFormContent(eventForm.data[0].customFields);
    }

    if (status === "success") {
      if (redirect) {
        window.location.href = `${redirect}`;
      }
      if (!redirect) {
        navigate(`/${eventDetails.name}/p/event-landing/${eventID}`);
      }
    }
  }, [eventForm?.data?.[0]?._id, status]);

  return (
    <React.Fragment>
      <div className="w-100 mt-2 d-flex justify-content-center">
        <h1
          id="schedule"
          className="d-flex justify-content-center"
          style={{ color: "black", fontWeight: "bold" }}
        >
          RSVP Now
        </h1>
      </div>
      <Divider />
      <div className="w-100 mt-4 mb-3 d-flex justify-content-center">
        <div
          style={{
            width: 650,
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
          }}
        >
          <div className="w-100 px-4 mb-2 mt-2">
            <form noValidate autoComplete="off" onSubmit={handleRegister}>
              <Row>
                <Col md={6}>
                  <div className="w-100 mb-2">
                    <label>
                      First Name<span className="text-danger">*</span>
                    </label>
                    <input
                      name="firstName"
                      type="text"
                      value={inputs.firstName}
                      className="form-control"
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <div className="text-danger">{errors.firstName}</div>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="w-100 mb-2">
                    <label>
                      Last Name<span className="text-danger">*</span>
                    </label>
                    <input
                      name="lastName"
                      type="text"
                      value={inputs.lastName}
                      className="form-control"
                      onChange={handleChange}
                    />
                    {errors.lastName && (
                      <div className="text-danger">{errors.lastName}</div>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="w-100 mb-2">
                    <label>
                      Email<span className="text-danger">*</span>
                    </label>
                    <input
                      name="email"
                      type="email"
                      value={inputs.email}
                      className="form-control"
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="w-100 mb-2">
                    <label>
                      Phone Number<span className="text-danger">*</span>
                    </label>
                    <div className="phone-input-container">
                      <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="ZA"
                        value={inputs.phoneNumber}
                        onChange={handlePhoneChange}
                        className="custom-phone-input"
                      />
                    </div>
                    {errors.phoneNumber && (
                      <div className="text-danger">{errors.phoneNumber}</div>
                    )}
                  </div>
                </Col>

                {formContent.slice(4)?.map((field) => {
                  const displayLabel = formatLabel(field?.label, field?.name);
                  return (
                  <Col md={12} key={field._id}>
                    <div className="mb-2">
                      {field.question_type !== "checkbox" && (
                        <label>{displayLabel}</label>
                      )}
                      {field.question_type === "text" && (
                        <input
                          type="text"
                          className="form-control"
                          placeholder={displayLabel}
                          name={field.name}
                          value={inputs[field.name] || ""}
                          onChange={handleChange}
                        />
                      )}
                      {field.question_type === "short_answer" && (
                        <input
                          type="text"
                          className="form-control"
                          placeholder={displayLabel}
                          name={field.name}
                          value={inputs[field.name] || ""}
                          onChange={handleChange}
                        />
                      )}
                      {field.question_type === "paragraph" && (
                        <textarea
                          rows={5}
                          className="form-control"
                          placeholder={displayLabel}
                          name={field.name}
                          value={inputs[field.name] || ""}
                          onChange={handleChange}
                        />
                      )}
                      {field.question_type === "options" && (
                        <select
                          className="form-control"
                          name={field.name}
                          value={inputs[field.name] || ""}
                          onChange={handleChange}
                        >
                          <option>Select...</option>
                          {field.list.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      )}
                      {field.question_type === "checkbox" && (
                        <FormControlLabel
                          control={
                            <CustomCheckbox
                              checked={!!inputs[field.name]}
                              onChange={(e) => {
                                setInputs((prev) => ({
                                  ...prev,
                                  [field.name]: e.target.checked,
                                }));
                                setErrors((prev) => ({ ...prev, [field.name]: "" }));
                              }}
                              name={field.name}
                            />
                          }
                          label={<Typography variant="body2">{displayLabel}</Typography>}
                        />
                      )}
                    </div>
                  </Col>
                  );
                })}
              </Row>

              <div className="w-100 mt-3 mb-2">
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      By signing up for and using Kago Events, you agree to the
                      collection, use, and sharing of your data as described in
                      this Data Usage Policy. Event entrance data will be sent
                      to you via email. Please be sure to check both your inbox
                      and spam folder to ensure you receive your event details.
                    </Typography>
                  }
                  style={{ alignItems: "start" }}
                />
                {errors.checkbox && (
                  <div className="text-danger">{errors.checkbox}</div>
                )}
              </div>

              <div className="w-100 mt-3 mb-2 d-flex justify-content-center">
                {isChecked ? (
                  <ButtonSubmit
                    Title="Submit"
                    ColorText="white"
                    BorderColor="#F68A20"
                    BackgroundColor="#F68A20"
                    borderRadius="25px"
                    handleOnclick={handleRegister}
                    pending={pending}
                  />
                ) : (
                  <ButtonSubmit
                    Title="Submit"
                    ColorText="white"
                    BorderColor="#D9D9D9"
                    BackgroundColor="#D9D9D9"
                    borderRadius="25px"
                    handleOnclick={() => {}}
                    pending={pending}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <Modal size="lg" isOpen={termsModal} toggle={openPolicy}>
        <ModalHeader toggle={openPolicy}>Data Usage Policy</ModalHeader>
        <ModalBody>
          <TermsAndCondition />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default FreeRegisterNow;
